import React from 'react'
import { Switch , Route } from 'react-router-dom'
import App from './App'
import loadingPage from './Loading'

const Router = ()=>{

    return (

        <Switch>

            <Route exact path="/" component={loadingPage} />

            <Route path="/index" component={App} />

        </Switch>

    )

}

export default Router;